import React from "react";
import { Input } from "reactstrap";

// Renderizador dinâmico de campo por Tipo (text/number/toggle/select/time/url/password).
// Extraído de ParametrosPage para reuso na aba "Configurar Integração" (H5, PO1-2550).
// Depende dos estilos .parametros-* de Parametros.css (importar no componente consumidor).

export function normalizeType(tipo) {
  if (tipo === "boolean") {
    return "toggle";
  }

  return tipo || "text";
}

export function getNormalizedValue(value) {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value);
}

export function safeParseOptions(rawOptions) {
  if (!rawOptions) {
    return [];
  }

  if (Array.isArray(rawOptions)) {
    return rawOptions;
  }

  try {
    const parsed = JSON.parse(rawOptions);

    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

export function buildInitialValue(param) {
  const paramType = normalizeType(param?.Tipo);
  const options = safeParseOptions(param?.Opcoes);

  if (paramType === "toggle") {
    return "Nao";
  }

  if (paramType === "select" && options.length > 0) {
    const firstOption = options[0];
    return getNormalizedValue(firstOption?.value !== undefined ? firstOption.value : firstOption);
  }

  return "";
}

export function renderControl({ param, valor, onChange, saving, fullWidth = false }) {
  const paramType = normalizeType(param?.Tipo);
  const options = safeParseOptions(param?.Opcoes);
  const suffix = param?.Sufixo;
  const min = param?.Min;
  const max = param?.Max;
  const placeholder = param?.Placeholder;
  const currentValue = getNormalizedValue(valor);

  if (paramType === "toggle") {
    const normalizedValue = currentValue.toLowerCase();
    const isOn = normalizedValue === "true" || normalizedValue === "sim" || normalizedValue === "1";

    return (
      <div className={`parametros-control ${fullWidth ? "parametros-control--full" : ""}`}>
        <button
          type="button"
          className={`parametros-toggle ${isOn ? "parametros-toggle--on" : ""}`}
          onClick={() => !saving && onChange(isOn ? "Nao" : "Sim")}
          disabled={saving}
          aria-pressed={isOn}
        >
          <span className="parametros-toggle__track">
            <span className="parametros-toggle__thumb" />
          </span>
          <span className="parametros-toggle__label">{isOn ? "Sim" : "Não"}</span>
        </button>
      </div>
    );
  }

  if (paramType === "select") {
    const normalizedOptions = options.map((option) => {
      if (option && typeof option === "object") {
        return {
          value: getNormalizedValue(option.value),
          label: option.label || getNormalizedValue(option.value),
        };
      }

      return {
        value: getNormalizedValue(option),
        label: getNormalizedValue(option),
      };
    });

    const hasCurrentOption = normalizedOptions.some(
      (option) => option.value === currentValue
    );

    const finalOptions = hasCurrentOption || currentValue === ""
      ? normalizedOptions
      : [{ value: currentValue, label: currentValue }, ...normalizedOptions];

    return (
      <div className={`parametros-control ${fullWidth ? "parametros-control--full" : ""}`}>
        <Input
          type="select"
          value={currentValue}
          disabled={saving}
          onChange={(event) => onChange(event.target.value)}
          style={{ width: fullWidth ? "100%" : 260 }}
        >
          <option value="">Selecione...</option>
          {finalOptions.map((option) => (
            <option key={`${param?.Id}-${option.value}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      </div>
    );
  }

  let inputType = "text";

  if (paramType === "number") {
    inputType = "number";
  } else if (paramType === "time") {
    inputType = "time";
  } else if (paramType === "url") {
    inputType = "url";
  } else if (paramType === "password") {
    inputType = "password";
  }

  if (inputType === "time" && currentValue && !/^\d{2}:\d{2}/.test(currentValue)) {
    inputType = "text";
  }

  if (inputType === "number" && currentValue !== "" && Number.isNaN(Number(currentValue))) {
    inputType = "text";
  }

  return (
    <div className={`parametros-control ${fullWidth ? "parametros-control--full" : ""}`}>
      <Input
        type={inputType}
        value={currentValue}
        disabled={saving}
        placeholder={placeholder || ""}
        min={min ?? undefined}
        max={max ?? undefined}
        onChange={(event) => onChange(event.target.value)}
        style={{ width: fullWidth ? "100%" : 260 }}
      />
      {suffix ? <span className="parametros-control__suffix">{suffix}</span> : null}
    </div>
  );
}
